import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=f3d99cdc&scoped=true&"
import script from "./NotificationItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=f3d99cdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d99cdc",
  null
  
)

export default component.exports